import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Breadcrumb from '../../menus/FleetBreadcrum'
import Fleet from '../../components/Fleet'

const compact_pick_upEn = props => (
  <div className="page  Compact pick Up">
  <Helmet
          title={` Compact pick Up Vehicles for Rent | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals. ',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href:
                './es/fleet/compact_pick_up',
            },
          ]}
        />
    <Breadcrumb
      lang={props.pathContext.langKey}
      currentPage={' Compact Pick Up Cars'}
    />
    <h1> Compact Pick Up</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={12}
    />
  </div>
)

export const query = graphql`
  query compact_pick_upEN {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default compact_pick_upEn



// WEBPACK FOOTER //
// ./src/pages/fleet/compact_pick_up.en.js